// Conversión USD/CLP con el tipo de cambio configurado en Administración
// (preferences.fxUsdClp), igual que Dashboard y Reportes.
export const makeConverter = (fxUsdClp) => (amount, fromCurrency, toCurrency) => {
  const value = Number(amount || 0);
  const from = fromCurrency === 'CLP' ? 'CLP' : 'USD';
  const to = toCurrency === 'CLP' ? 'CLP' : 'USD';
  const fx = Number(fxUsdClp);
  if (from === to || !Number.isFinite(fx) || fx <= 0) return value;
  return from === 'CLP' ? value / fx : value * fx;
};

export const formatIndex = (value) => (value == null || !Number.isFinite(value) ? '—' : value.toFixed(2));

export const formatPct = (value, decimals = 1) =>
  value == null || !Number.isFinite(value) ? '—' : `${value.toFixed(decimals)}%`;
